import { Box, Table, Text } from "@chakra-ui/react";
import { formatNumber } from "../../../../store/helpers";
import LineGraph from "../../../daily/LineGraph";
import ConfiguredReportTable from "../../../reports/ConfiguredReportTable";
import { TICKET_SUMMARY_COLUMN_DEFINITIONS } from "../../../../store/renderConfig";
import { renderTicketSummaryCell } from "../AllTicketsTable";

const TicketsPerBranchTable = ({ branchData, index, reportIndex, renderConfig }) => {
  const {
    branchName,
    min,
    max,
    total,
    average,
    totalPct,
    numServices,
    chart,
    totalCompleted,
    completedPct,
    totalNoShow,
    noShowPct,
    totalUnattended,
    unattendedPct,
  } = branchData;

  const title = `${reportIndex || ""}.${index + 1}. ${branchName} Branch`;

  if (!renderConfig?.charts?.enabled) {
    return (
      <Box className="ticketSummaryBlock">
        <h2>{title}</h2>
        <Text>{numServices} services</Text>
        <ConfiguredReportTable
          columns={TICKET_SUMMARY_COLUMN_DEFINITIONS}
          rows={[{
            ...branchData,
            scopeName: `${branchName} Branch`,
            completed: totalCompleted,
            noShow: totalNoShow,
            unattended: totalUnattended,
          }]}
          renderConfig={renderConfig}
          renderCell={renderTicketSummaryCell}
        />
      </Box>
    );
  }

  return (
    <Box>
      <h2>{title}</h2>
      <Text>{numServices} services</Text>

      {total ? (
        <Table.Root className="stripedTable" size="sm">
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>#</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Average</Table.ColumnHeader>
              <Table.ColumnHeader>Min</Table.ColumnHeader>
              <Table.ColumnHeader borderRight="1px solid #dadce0">Max</Table.ColumnHeader>
              <Table.ColumnHeader>Completed</Table.ColumnHeader>
              <Table.ColumnHeader>No Show</Table.ColumnHeader>
              <Table.ColumnHeader>Unattended</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{index + 1}</Table.Cell>
              <Table.Cell borderRight="1px solid #dadce0">
                {" "}
                <Text color={"var(--green)"}>
                  {formatNumber(total)}
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    ({totalPct.toFixed(2)}%)
                  </Box>
                </Text>
              </Table.Cell>

              <Table.Cell borderRight="1px solid #dadce0">{formatNumber(average)}</Table.Cell>
              <Table.Cell>{formatNumber(min)}</Table.Cell>
              <Table.Cell>{formatNumber(max)}</Table.Cell>
              <Table.Cell>
                <Text color={"var(--green)"}>
                  {!isNaN(totalCompleted) ? formatNumber(totalCompleted) : "NA"}
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    {!isNaN(completedPct)
                      ? `(${completedPct.toFixed(2)})%`
                      : "NA"}
                  </Box>
                </Text>
              </Table.Cell>

              <Table.Cell>
                <Text cursor="pointer" color={"var(--red)"}>
                  {!isNaN(totalNoShow) ? formatNumber(totalNoShow) : "NA"}
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    {!isNaN(noShowPct) ? `(${noShowPct.toFixed(2)})%` : "NA"}
                  </Box>
                </Text>
              </Table.Cell>

              <Table.Cell>
                <Text color={"var(--red)"}>
                  {!isNaN(totalUnattended)
                    ? formatNumber(totalUnattended)
                    : "NA"}
                  <Box
                    color="gray.500"
                    fontWeight="semibold"
                    fontSize="xs"
                    textTransform="uppercase"
                  >
                    {!isNaN(unattendedPct)
                      ? `(${unattendedPct.toFixed(2)})%`
                      : "NA"}
                  </Box>
                </Text>
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell colSpan={8}>
                <Box mt="20px" mb="20px">
                  <LineGraph
                    chart={chart}
                    title={`${branchName} tickets, Hour by Hour Comparison`}
                    height={"300px"}
                  />
                </Box>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table.Root>
      ) : (
        <>
          {" "}
          <Text fontSize="sm">No data available for this report</Text>
        </>
      )}
    </Box>
  );
};

export default TicketsPerBranchTable;
